import { scan } from "@pdfking/rfunc"

import state from "../state/main"

export default (key, value) => scan(v => state[key].push(v), value)
